module.exports = __webpack_public_path__ + "static/media/78.218c0ae1.png";